import {
  faClock,
  faLocationDot,
  faUserSecret,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useSelector } from "react-redux";
import { extractOnlyTwoDigitDate } from "../../../../utils/extractOnlyTwoDigitDate";
import { extarctOnlyMonth } from "../../../../utils/extarctOnlyMonth";
import { extarctOnlyDay } from "../../../../utils/extarctOnlyDay";
import { extractIntoDDMMFormat } from "../../../../utils/extractIntoDDMMFormat";
import { formatTimeRange } from "../../../../utils/formattedTimeRange";
import { useNavigate } from "react-router-dom";


const OrderDetailsJobList = () => {
  const { jobOrdersListsById } = useSelector((state) => state.orders)
  const navigate = useNavigate()

  return (
    <>
      <div className="upcoming-box-row">

        {jobOrdersListsById && jobOrdersListsById?.length > 0 && jobOrdersListsById?.map((item, idx) => {
          return (
            <>

              <div className="upcoming-box-col" key={idx + 1} onClick={() => navigate(`/booking-details/${item?._id}`, { state: { selectedJobId: item?._id, itemOfList: item } })}>
                <div className="upcoming-date-time-wrap">
                  <div className="upcoming-date">{extractOnlyTwoDigitDate(item?.startDate)}</div>
                  <div className="upcoming-month">{extarctOnlyMonth(item?.startDate)}</div>
                  <div className="upcoming-day"> {extarctOnlyDay(item?.startDate)}</div>
                </div>

                <div className="upcoming-box-right">
                  <div className="upcoming-heading-wrap">
                    <div className="upcoming-heading">
                      <h5>

                        {`${item?.order_id?.orderType?.charAt(0).toUpperCase()}${item?.order_id?.orderType?.slice(1)} Cleaning`}
                        <span className="up-count">{`(${idx + 1}/${jobOrdersListsById?.length})`}</span>
                      </h5>
                    </div>
                    <div className="upcm-add">
                      <div className="upcm-add-details">
                        <ul className="list-unstyled">
                          <li>
                            {/* <FontAwesomeIcon icon={faLocationDot} /> */}
                            <img src="/assets/images/img-icon1.png" />

                            {item?.order_id?.address?.displayAddress?.title}
                          </li>
                        </ul>
                      </div>
                      <ul className="list-unstyled">
                        <li>
                          {/* <FontAwesomeIcon icon={faClock} /> */}
                          <img src="/assets/images/img-icon2.png" />

                          {formatTimeRange(item?.startDate, item?.endDate)}
                        </li>
                        {item?.assignTo && item?.assignTo?.length > 0 && item?.assignTo?.map((assignItem, idxOfAssign) => {
                          return (
                            <>
                              {assignItem?.staff_id?.name && <li>
                                {/* <FontAwesomeIcon icon={faUserSecret} /> */}
                                <img src="/assets/images/img-icon3 (1).png" />

                                {assignItem?.staff_id?.name}
                              </li>}
                            </>
                          )
                        })}

                      </ul>
                    </div>
                  </div>
                </div>
                {item?.status && item?.status == "Upcoming" ? (
                  <div className="up-yellow up-green">
                    <p className="mb-0"> {item?.status}</p>
                  </div>
                ) : (
                  <div className="up-green ">
                    <p className="mb-0"> {item?.status}</p>
                  </div>
                )}
              </div>
            </>
          )
        })}
      </div>
    </>
  );
};

export default OrderDetailsJobList;
